import useEstateSell from "@/domains/estate/hooks/useEstateSell";
import EstateSellModal from "@/domains/estate/components/EstateSellModal";

type Props = {
  setIsShow: (isShow: boolean) => void;
  onSuccessSell: () => void;
};

export default function EstateSellContainer({ setIsShow, onSuccessSell }: Props) {
  const { price, estate, sell, isSelling, isLoading } = useEstateSell({ setIsShow, onSuccessSell });

  return (
    <EstateSellModal
      estateId={estate.id}
      estateType={estate.type}
      price={price}
      estatePrice={estate.price}
      onClose={() => setIsShow(false)}
      onConfirm={sell}
      address={estate.address}
      isLoading={isLoading}
      isConfirming={isSelling}
    />
  );
}
